class Timeline {
    constructor($timeline) {
        if (!$timeline)
            return;

        this.$timeline = $timeline;
        this.$items = this.$timeline.querySelectorAll('.timeline-item');

        [...this.$items].forEach($el => {
            $el.querySelector('.timeline-toggle').addEventListener('click', e => {
                let $desc = $el.querySelector('.timeline-desc');

                $desc.style.maxHeight = $desc.querySelector('.timeline-desc-inner').offsetHeight + 'px';
                $el.setAttribute('aria-expanded', $el.getAttribute('aria-expanded') === 'false');
            });
        });
    }
}

export default Timeline;
